import React from 'react';
import '../../App.css';


export default function MateriaisBibliograficos() {
    return <>
        <body className='bibliograficos'>
            {/*<h1 className='title'>Materiais Bibliogr&aacute;ficos</h1>
            <div className= "row">
                <img class="teste1" src={"./bibliograficos/teste1.png"} />
                <p className="texto"> Essa Imagem eh um teste de um material bibliografico que poderia ser um material serio de estudo</p>
            </div>
            <div className= "row">
                <img class="teste1" src={"./bibliograficos/teste2.png"} />
                <p className="texto"> Essa Imagem eh um teste de um material bibliografico que poderia ser um material serio de estudo</p>
            </div>*/}
        </body>
    </>;

}